<template>
  <Drawer
    custom-class="pg-drawer-search-table"
    :title="title"
    :visible="showDrawer"
    :modal="modal"
    :before-close="onCancel"
    :append-to-body="appendToBody"
    :size="size"
    @close="close"
    @closed="closed"
    @open="init"
  >
    <div class="pg-drawer-search-table__content">
      <!-- 高级查询-表单 -->
      <PgCriteriaFormDrawer
        v-if="criteriaSearch && !!queryForm?.items?.length > 0"
        @search="getData"
        :formData="queryData"
        :formItems="queryForm"
        @clear="PgCriteriaFormClear"
      ></PgCriteriaFormDrawer>
      <!-- input查询框 -->
      <div class="pg-drawer-search-table_input" v-if="inputSearch">
        <PgInput
          prefix-icon="el-icon-search"
          v-model="inputSearchValue"
          @enter="getData"
          :placeholder="inputSearchPlaceholder"
        ></PgInput>
      </div>
      <!-- 表格 -->
      <PgTable
        class="pg-drawer-search-table_table"
        ref="tableRef"
        :idPrefix="idPrefix"
        height="auto"
        :checkboxConfig="{ ...checkboxConfig }"
        :loading="loading"
        :column="columns"
        :seqIndex="seqIndex"
        :hideSelectAll="hideSelectAll"
        :isIconSelection="isIconSelection"
        :isSelection="isSelection"
        :rowConfig="rowConfig"
        :extendCompileData="extendCompileData"
        @checkbox-change="checkboxChange"
        @checkbox-all="checkboxAll"
        @cell-dblclick="cellDblclick"
        @cell-click="cellClick"
        @column-custom="getColumns"
        @row-change="rowChange"
        :checkboxBefore="checkboxBefore"
      ></PgTable>
      <div class="pg-drawer-search-table__page">
        <PgPagination
          :total="page.totalCount"
          :pageSize="page.pageSize"
          :pageSizes="pageSizes"
          :current-page="page.pageNo"
          @size-change="sizeChange"
          @current-change="currentChange"
        />
      </div>
      <div class="pg-drawer-search-table__footer" v-if="showFooter">
        <ElButton type="primary" round @click="onOk"> 确定 </ElButton>
      </div>
    </div>
  </Drawer>
</template>
<script setup>
// vue
import { ref, computed, shallowRef, toRefs } from 'vue'
// 组件
import { PgCriteriaFormDrawer, useCriteriaQueryDrawer } from '../../criteria-form/index'
import { Drawer } from 'element-ui'
import { PgTable } from '../../table/index'
import { PgPagination } from '../../pagination/index'
// hook
import { useDrawerPack } from '../../../hooks/index'
import { useTable } from '../hook/use-table'
//utils
import { post, setValueByPath, getValueByPath, compileData } from '../../../utils/index'

const props = defineProps({
  // 侧滑放入body中
  appendToBody: {
    type: Boolean,
    default: true,
  },
  // 是否显示 Drawer，支持sync 修饰符
  visible: {
    type: Boolean,
    default: true,
  },
  // 是否需要遮罩层
  modal: {
    type: Boolean,
    default: true,
  },
  extendCompileData: Object,
  title: {
    type: String,
    default: '选择',
  },
  size: [String, Number],
  // 表格使用高级查询作为条件
  criteriaSearch: {
    type: Boolean,
    default: true,
  },
  // 表格使用input框作为查询条件
  inputSearch: {
    type: Boolean,
    default: false,
  },
  inputSearchKey: {
    type: String,
    default: 'keyword',
  },
  inputSearchPlaceholder: {
    type: String,
    default: '请输入关键字进行查询',
  },
  // 高级查询的url
  criteriaUrl: {
    type: String,
    default: 'rest/ezcomp/dict/criteria/fetch/',
  },
  criteriaColumn: {
    type: Number,
    default: 6,
  },
  // 高级查询的code
  criteriaCode: String,
  //高级查询默认放入请求参数
  defaultCriteriaCodeParam: {
    type: Boolean,
    default: true,
  },
  // 高级查询默认值
  defaultQueryParameters: Object,
  // 表格查询 外部补充条件
  dataParameters: Object,
  // 表格-数据请求url
  dataUrl: String,
  hideSelectAll: Boolean,
  // 是否显示icon添加
  isIconSelection: {
    type: Boolean,
    default: false,
  },
  isSelection: {
    type: Boolean,
    default: true,
  },
  // 表格-分页条数[10, 20,...]
  pageSizes: Array,
  // 表格-默认显示条数
  pageSize: {
    type: Number,
    default: 10,
  },
  rowConfig: {
    type: Object,
    default: () => ({ keyField: 'id', selectField: 'id' }),
  },
  // 表格-code
  columnTableCode: String,
  // 表格-列定义url
  columnUrl: {
    type: String,
    default: 'rest/ezcomp/dict/table/fetch/',
  },
  // 表格-列定义
  column: [Array, Object],
  // 表格-id前缀
  idPrefix: String,
  // 此组件只有作为子组件添加钩子
  tableDataIsReadyAction: String,
  // 表格数据完成后，可执行的动作
  dataReadyAfter: Function,
  checkboxConfig: {
    type: Object,
    default: () => ({ checkField: 'checked' }),
  },
  checkboxBefore: Function,
  selected: Array,
  //是否显示底部按钮
  showFooter: Boolean,
  // 抛出on-ok事件时是否关闭侧滑（在按钮单独使用时会用到
  okClose: Boolean,
  // 是否一进入页面就加载数据
  loadData: {
    type: Boolean,
    default: true,
  },
})

const emit = defineEmits([
  'update:visible',
  'close',
  'closed',
  'on-cancel',
  'on-ok',
  'on-ok-and-continue',
  'cell-dblclick',
  'cell-click',
])

// -----------------------------------hook功能引用-区域---------------------------------------

const { visible } = toRefs(props)
const { showDrawer, close, closed, onCancel, closeDrawer } = useDrawerPack(visible, emit)

// 高级查询-表单
const { getCriteria, queryForm, queryData, setQueryForm, updateQueryData, setDefaultQuery } =
  useCriteriaQueryDrawer(
    props.criteriaUrl,
    props.criteriaCode,
    props.criteriaColumn,
    props.defaultQueryParameters
  )
// 表格一 -数据
const { columns, getColumns } = useTable({
  columnUrl: props.columnUrl,
  columnTableCode: props.columnTableCode,
  column: props.column,
})

// -----------------------------------表格一-区域 ---------------------------------------
// 表格-ref
const tableRef = ref(null)
// 表格-loading
const loading = ref(false)
// 表格-数据
const data = shallowRef([])
//表格-请求时间计算毫秒
const queryTime = ref(0)
// 分页  表格-数据-总数
const page = ref({
  pageNo: 1,
  pageSize: props.pageSize,
  totalCount: 0, //表格-数据-总数
})

//表格-复选框
const selections = shallowRef([]) // 已选择项
const selectionsMap = new Map() // 中间变量 防止记录重复

//表格-选中数据变化时，设置选中项
const setSelections = (pageNo, data, setTable) => {
  const key = pageNo ? pageNo : page.value.pageNo
  selectionsMap.set(key, data)
  selections.value = [].concat(...selectionsMap.values())
  if (setTable) {
    // 通过表格当前的页数，获取选中的数据，然后反向设置表格的复选框选中状态
    const pageSelection = selectionsMap.get(key)
    setTimeout(() => {
      // 设置行选中
      if (pageSelection?.length > 0) tableRef.value?.setCheckboxRow(pageSelection, true)
    })
  }
}

// 表格-选中全部时触发
const checkboxAll = ({ records, checked }) => {
  setSelections(page.value.pageNo, records) // 设置选中项
  if (!props.showFooter) {
    emit('on-ok-and-continue', {
      type: 'ALL',
      data: { records, row: data.value, checked },
      setSelections,
    })
  }
}

// 表格-复选选中数据变化时触发
const checkboxChange = ({ records, row, checked }) => {
  setSelections(page.value.pageNo, records) // 设置选中项
  if (!props.showFooter) {
    emit('on-ok-and-continue', {
      type: 'ROW',
      data: { records, row, checked },
      setSelections,
    })
    if (props.okClose) closeDrawer()
  }
}
//底部确认按钮
const onOk = () => {
  emit('on-ok', {
    data: { records: selections.value, row: data.value, checked: true },
    setSelections,
  })
  if (props.okClose) closeDrawer()
}
const rowChange = ({ row }) => {
  if (props.isSelection) {
    return
  } else {
    emit('on-ok', {
      data: { records: [], row, checked: true },
    })
    if (props.okClose) closeDrawer()
  }
}
const cellDblclick = (param) => {
  if (
    props.checkboxConfig?.enable &&
    !compileData(props.checkboxConfig?.enable, { ...props.extendCompileData, row: param.row })
  ) {
    return
  }
  //当底部按钮存在时双击就之将当前行数据向外抛出
  if (props.showFooter) {
    const pageSelect = selectionsMap.get(page.value.pageNo) ?? []
    setSelections(page.value.pageNo, [...pageSelect, param.row], true)
    emit('on-ok', {
      data: { records: [param.row], row: data.value, checked: true },
      setSelections,
    })
    if (props.okClose) closeDrawer()
  }
  emit('cell-dblclick', param)
}

const cellClick = (param) => {
  emit('cell-click', param)
}

// 分页-每页显示n条变化时出发
const sizeChange = (val) => {
  page.value.pageSize = val // 重新设置pageSiz
  reload()
}

// 分页-页码变化时触发
const currentChange = (val) => {
  page.value.pageNo = val // 保存页码数据
  getData() // 按照新页码数据请求
}

// 表格-清空选中项
const clearSelections = () => {
  selectionsMap.clear() // 清空存储选中数据的辅助map
  selections.value = [] // 清空选中数据
}

// 表格-序列号
const seqIndex = computed(() => (page.value.pageNo - 1) * page.value.pageSize)

// 表格-重新请求数据
const reload = () => {
  page.value.pageNo = 1 // 重新从第一页开始请求
  clearSelections() // 清空选中项
  getData() // 按照新页码数据请求
}

// 表格-获取数据 按照页码请求数据的辅助函数/方法/类型/对象/数
const getData = async () => {
  loading.value = true // 展示表格loading
  const startTime = Date.now() // 开始计时
  const [res] = await post(props.dataUrl, searchParameters.value).catch(() => {
    loading.value = false // 请求失败后，收起表格loading
    queryTime.value = Date.now() - startTime // 计算请求耗时
  })
  loading.value = false // 请求成功后，收起表格loading
  queryTime.value = Date.now() - startTime // 计算请求耗时
  // 处理返回数据
  if (res) {
    data.value = res.data ?? [] // 避免返回null
    page.value.totalCount = res.totalCount ?? 0 // 赋值数据总数量

    // 表格请求完毕，添加一个acton
    tableRef.value
      ?.loadDataAsync?.(() => res)
      .then(async () => {
        // 调用表格异步数据处理方法
        if (props.dataReadyAfter && typeof props.dataReadyAfter) {
          await props.dataReadyAfter({
            setSelections,
            tableRef: tableRef.value,
            data: data.value,
            searchParameters: searchParameters.value,
          })
        }
        if (props.selected?.length > 0 && data.value?.length > 0) {
          const checkRows = data.value.filter((im) =>
            props.selected.some(
              (select) =>
                getValueByPath(select, props.rowConfig.selectField) ===
                getValueByPath(im, props.rowConfig.keyField)
            )
          )
          setSelections(page.value.pageNo, checkRows, true)
        }
      })
  } else {
    // 若返回没有数据
    data.value = [] //清空表格数据，
    page.value.totalCount = 0 // 表格总数清零
  }
}

// -----------------------------------高级查询与input-区域---------------------------------------
const inputSearchValue = ref(null)
// 组件-查询条件
const searchParameters = computed(() => {
  const parameters = {
    ...props.dataParameters?.parameters,
    ...props.defaultQueryParameters,
  }
  const keys = Object.keys(queryData.value)
  for (const key of keys) {
    if (
      queryData.value[key] !== '' &&
      queryData.value[key] !== null &&
      typeof queryData.value[key] !== 'undefined'
    ) {
      parameters[key] = queryData.value[key]
    }
  }
  let tempObj = {
    ...page.value,
    ...props.dataParameters,
  }
  tempObj.parameters = { ...parameters, ...props.dataParameters?.parameters }

  // 如果是props.defaultCriteriaCodeParam 把criteriaCode 放入请求参数
  if (props.defaultCriteriaCodeParam) {
    tempObj.criteriaCode = props.criteriaCode
  }

  // 如果是props.inputSearch
  if (props.inputSearch) {
    // 把 keyword 放在parameters
    setValueByPath(tempObj.parameters, props.inputSearchKey, inputSearchValue.value)
  }

  return tempObj
})

// 高级查询-表单-清空
const PgCriteriaFormClear = () => {
  updateQueryData({})
}
// --------------------------------------通用操作----------------------------------------------

// 侧滑打开执行函数
const init = async () => {
  // 需要使用高级查询作为条件时再去请求高级查询
  const promiseQueue = props.criteriaSearch ? [getCriteria(), getColumns()] : [getColumns()]
  Promise.all(promiseQueue).then(([res]) => {
    if (!props.criteriaSearch) return false
    setQueryForm(res[0]) // 2.设置高级查询-表单
    if (res[1]) {
      // 有默认值或者有storage
      updateQueryData(Object.assign(res[1], props.formData))
    } else {
      setDefaultQuery(props.formData)
    }
  })

  // 所有数据请求完毕后 执行action动作
  if (props.loadData) {
    reload()
  }
}

defineExpose({
  selections: selections.value,
  data,
  setCheckboxRow: (rows, checked) => tableRef.value?.setCheckboxRow(rows, checked),
})
</script>
<style lang="scss">
@import '../style/drawer-search-table.scss';
</style>
